"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAX_TYPE = exports.DEFAULT_STYLE = void 0;
var DEFAULT_STYLE = {
  LABEL_TYPE: 'sub',
  LABEL_DISPLAY: 'inlineFlex',
  SUB_LABEL_TYPE: 'small',
  SUB_LABEL_DISPLAY: 'inlineFlex',
  SUB_LABEL_COLOR: 'greyDark'
};
exports.DEFAULT_STYLE = DEFAULT_STYLE;
var PAX_TYPE = {
  adult: 'adult',
  child: 'child',
  infant: 'infant'
};
exports.PAX_TYPE = PAX_TYPE;